import React, { FC } from 'react';
import { Container, makeStyles } from '@material-ui/core';
import useBreakpoint from 'hooks/use-breakpoint';

const useStyles = makeStyles(() => ({
  navSpace: {
    marginTop: 32,
  },
}));

const UseBreakpointHook: FC = () => {
  const classes = useStyles();
  const { innerWidth, breakpoint } = useBreakpoint();

  return (
    <Container maxWidth="md" className={classes.navSpace}>
      <div>width: {innerWidth}</div>
      <div>breakpoint: {breakpoint}</div>
    </Container>
  );
};

export default UseBreakpointHook;
